module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/reply-48d3fd77aaadfe51e44f9d6856cb3037.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/reply.svg
// module id = KURn
// module chunks = 24